import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const UnauthorizedError: React.FC = () => {
  const navigate = useNavigate();
  const backHome = () => {
    navigate('/');
  };
  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Button type="primary" onClick={backHome}>
          Back Home
        </Button>
      }
    />
  );
};

export default UnauthorizedError;
